import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AppComponent } from 'src/app/app.component';
import { ChannelsService } from 'src/app/services/channels.service';
import { PlaylistService } from 'src/app/services/playlist.service';
import { MediaSummary } from '../../models';

@Component({
  selector: 'show-details-banner',
  templateUrl: './show-details-banner.component.html',
  styleUrls: ['./show-details-banner.component.scss']
})
export class ShowDetailsBannerComponent implements OnInit, AfterViewInit {

	newVideo: boolean = false;
	progress: number;

	@Input() media: MediaSummary;
	@Input() seriesView: boolean;
	@Input() heroWeb: string;
	@Input() heroMobile: string;
	@Input() logo: string;


	heroWebImage: string;


	constructor(
		private app: AppComponent) {
	}

	ngOnInit(): void {
		this.heroWebImage = this.media.images.find(x => x.type === 'hero-web')?.url;
	}

    ngAfterViewInit() {

    }

	isAuthenticated() {
		return this.app.isAuthenticated();
	}
}
